import { FileAttachment } from './file-attachment';

export class PublisherNote {
  createdOn: string;
  id: string;
  note: string;
  publisherId: string;
  user: string;
  fileAttachments: FileAttachment[];
}
